import { render, staticRenderFns } from "./connect_statistics.vue?vue&type=template&id=1f3701f4&scoped=true"
import script from "./connect_statistics.vue?vue&type=script&lang=ts"
export * from "./connect_statistics.vue?vue&type=script&lang=ts"
import style0 from "./connect_statistics.vue?vue&type=style&index=0&id=1f3701f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3701f4",
  null
  
)

export default component.exports